<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar color-sidebar-white" :class="!showSidebar ? 'collapse-sidebar' : ''">
   
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-small-cap"> <span> Dashboard </span></li>
          <li> 
            <a href="#/dashboard"> 
               <fa-icon class="md-size-1x mr-3" icon="home"></fa-icon>
              <span class="hide-menu"> Dashboard </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/pohon"> 
               <fa-icon class="md-size-1x mr-3 text-warning" icon="share-alt"></fa-icon>
              <span class="hide-menu">Laporan Kinerja</span> 
            </a> 
          </li>
           <li class="nav-small-cap"> <span> ASPEK KINERJA </span></li>
           <li> 
            <a href="#/kinerja/skp"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-bar"></fa-icon>
              <span class="hide-menu"> Monitoring SKP </span> 
            </a> 
          </li>
           
           <li> 
            <a href="#/kinerja/lhkp"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-line"></fa-icon>
              <span class="hide-menu"> Monitoring LHKP </span> 
            </a> 
          </li>
           <li> 
            <a href="#/kinerja/review"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-area"></fa-icon>
              <span class="hide-menu">Monitoring Review 360 </span> 
            </a> 
          </li>

         
          <li class="nav-small-cap"> <span> ASPEK DISIPLIN </span></li>
          <li> 
            <a href="#/prolap/renstra"> 
               <fa-icon class="md-size-1x mr-3 text-success" icon="envelope"></fa-icon>
              <span class="hide-menu"> Monitoring Kehadiran </span> 
            </a> 
          </li>
          <li> 
            <a href="#/prolap/renstra"> 
               <fa-icon class="md-size-1x mr-3 text-success" icon="envelope"></fa-icon>
              <span class="hide-menu"> Monitoring Cuti  </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/evaluasi"> 
               <fa-icon class="md-size-1x mr-3 text-primary" icon="map" ></fa-icon>
              <span class="hide-menu"> Monitoring Pelanggaran </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/laporan"> 
               <fa-icon class="md-size-1x mr-3" icon="copy"></fa-icon>
              <span class="hide-menu"> Monitoring Manipulasi  </span> 
            </a> 
          </li>
         
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
    //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
        menuItem : [] 
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations({
     // toggleDropdown: "toggleDropdown"
    }),
     toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    fetchData() {

            this.$store.dispatch('getData',{
                url :  'api/site/apimenu?f=vue' 
            }) .then(response => {
                 this.menuItem  = response.data.data
            }).catch((error) => {
                alert(error)
            }) 

       
    }
  }
};
</script>

<style scoped>
.collapse-sidebar {
  width: 70px;
}
.collapse-sidebar #sidebarnav > li > a.has-arrow:after {
  display: none;
}
.svg-inline--fa {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Kinerja.vue